import React from "react";
import scrollTo from 'gatsby-plugin-smoothscroll';

import classes from "./item.module.scss";

const Item = props => {

    const clickHandler = () => {
        props.clicked();
        scrollTo(`#${props.id}`);
    }

  return (
    <li className={classes.Item}>
      <span onClick={clickHandler}>
        {props.content}
      </span>
    </li>
  )
}

export default Item
